import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ApiError } from '@/lib/api-error.js';
import { ToastProvider } from '@/components/ui/Toast.js';
import { AuthProvider } from '@/features/auth/auth-context.js';
import { AppRoutes } from '@/app/routes.js';

/**
 * So'rovlar sozlamasi.
 *
 * 4xx xatolarida QAYTA URINILMAYDI: «huquq yo'q» yoki «topilmadi» javobi
 * uch marta so'ralsa ham o'zgarmaydi, faqat serverni bezovta qiladi.
 * Tarmoq xatosida esa bir marta qayta urinish arziydi.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 1;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

/**
 * Ma'lumot marshrutizatori (data router).
 *
 * `BrowserRouter` EMAS: `useBlocker` — saqlanmagan o'zgarish bilan
 * chiqishni ushlab qoladigan yagona qo'llab-quvvatlanadigan API — faqat
 * data router ichida ishlaydi. `BrowserRouter` bilan u ishga tushishi
 * bilan xato tashlaydi va butun tahrirlash ekrani oq qolardi.
 *
 * Yo'llar `AppRoutes` ichida `<Routes>` bo'lib qolaveradi: bu React
 * Router hujjatlaridagi «asta-sekin o'tish» usuli — ildizda bitta splat
 * yo'l, ichida esa odatdagi daraxt.
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    ),
  },
]);

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
